import { compareAsc, parseISO } from 'date-fns';

/**
 * @typedef {object} HoldDownCrewMember
 * @property {string} id
 * @property {string} fullName
 * @property {string} [__typename]
 */

/**
 * @typedef {object} HoldDown
 * @property {string} id
 * @property {HoldDownCrewMember} originalCrewMember
 * @property {string} effectiveTimestamp
 * @property {string} expireTimestamp
 * @property {string} [note]
 * @property {string} [__typename]
 */

/**
 * Picks the hold down that should be shown in the crew member replacement warning.
 *
 * Product behavior:
 * - Exclude hold downs where the crew member is themselves the original (replacement row).
 * - Among the remaining, pick the one with the oldest effectiveTimestamp regardless of
 *   whether it is in the past, present, or future.
 *
 * @param {HoldDown[]} holdDowns
 * @returns {HoldDown|undefined}
 */
export const getCurrentHoldDown = (holdDowns, employeeInfo) => {
	const [currentHoldDown] = holdDowns
		.filter((holdDown) => holdDown.originalCrewMember?.id !== employeeInfo?.id)
		.sort((a, b) => compareAsc(parseISO(a.effectiveTimestamp), parseISO(b.effectiveTimestamp)));

	return currentHoldDown;
};
